// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3W94h","bigColWidth":"Table_bigColWidth__1Q2wn","biggerColWidth":"Table_biggerColWidth__2wcFE","row":"Table_row__3Mza4","col":"Table_col__3qGuH"};